import { MantineThemeOverride } from '@mantine/core';

export type RadioTheme = NonNullable<MantineThemeOverride['components']>['Radio'];

export const Radio: RadioTheme = {
  // todo: define
};
